// Copyright (c) 2017 Deere & Company

import Claims from '../state/claims';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const updateClaimsInProgress = (state, action) =>
    Claims.update(state, {
        $set: action.data
    });

const resetClaimsInProgress = state =>
    Claims.update(state, {
        $set: getDefaultState().claims
    });

export default (state = getDefaultState().claims, action) => {

    const actionTypes = {
        [actions.RESET_CLAIMS_IN_PROGRESS]: resetClaimsInProgress,
        [actions.UPDATE_CLAIMS_IN_PROGRESS_DATA]: updateClaimsInProgress
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/claims-in-progress/reducers/claims.js